import { Button, Card } from "antd";
import { useEffect, useState } from "react";
import himsIcon from "../../Assets/images/sidebar-icons/HIMS.svg";
import "../../Views/HIMS/hims.css";
import rupeeIcon from "../../Assets/images/rupee.svg";
import himsCheck from "../../Assets/images/hims_check.svg";
import PaymentDetails from "../../Components/hims/PaymentDetails";
import ChoosePlan from "../../Components/hims/ChoosePlan";
import PaymentSuccess from "../../Components/hims/PaymentSuccess";

function Hims(props) {
  const [showChoosePlan, setShowChoosePlan] = useState(false);

  useEffect(() => {
    props.setActiveSideKey("8");
  }, []);

  return (
    <>
      <Card
        title={
          <div
            style={{ display: "flex", alignItems: "center", gap: "0.75rem" }}
          >
            <img
              src={himsIcon}
              alt="icon"
              style={{
                filter:
                  "invert(61%) sepia(66%) saturate(4119%) hue-rotate(110deg) brightness(103%) contrast(105%)",
                height: "28px",
                width: "auto",
                marginBottom: "0.5rem",
              }}
            />
            <h1 style={{ color: "#01D35A" }}>HIMS</h1>
          </div>
        }
        className="hims-card-container"
        headStyle={{ marginLeft: "180px", height: "64px" }}
      >
        <div>
          <div className="title-heading">
            Compare all Features & Choose the right plan
          </div>
        </div>
        <div>
          <ChoosePlan
            isModalOpen={showChoosePlan}
            setIsModalOpen={setShowChoosePlan}
          />
        </div>
        <HimsTable />
      </Card>
    </>
  );
}

export default Hims;

function PlanCard({
  title,
  isActive,
  pricePerMonth,
  callBack,
  btnBackgrondColor,
  setShowChoosePlan,
}) {
  return (
    <div className="plan-card">
      <div style={{ fontSize: "24px", fontWeight: "600" }}>{title}</div>
      <div
        style={{
          fontSize: "16px",
          fontWeight: "600",
          display: "flex",
          alignItems: "center",
          gap: "4px",
          marginBottom: "4px",
        }}
      >
        <img src={rupeeIcon} height={26} width={26} />
        <span>{pricePerMonth}/Month</span>
      </div>
      <Button
        className="btn"
        type="primary"
        style={btnBackgrondColor ? { backgroundColor: btnBackgrondColor } : {}}
        onClick={() => {
          setShowChoosePlan(true);
        }}
      >
        Select Plan
      </Button>
    </div>
  );
}

const HimsTable = () => {
  const [showChoosePlan, setShowChoosePlan] = useState(false);
  const data = [
    ["S No.", "Modules", "", "", "", ""],
    ["1.", "Front Office", "Yes", "Yes", "Yes", "Yes"],
    ["2.", "OP Billing", "Yes", "Yes", "Yes", "Yes"],
    ["3.", "Laboratory Management", "Yes", "Yes", "Yes", "Yes"],
    ["4.", "Supply Chain Management", "Yes", "Yes", "Yes", "Yes"],
    ["5.", "Doctor Appointment", "Yes", "Yes", "Yes", "Yes"],
    ["6.", "MIS Reports", "Yes", "Yes", "Yes", "Yes"],
    ["7.", "EMR Basic", "Yes", "Yes", "Yes", "Yes"],
    ["8.", "OP Pharmacy", "Yes", "Yes", "Yes", "Yes"],
    ["9.", "Issue Tracker", "Yes", "Yes", "Yes", "Yes"],
    ["10.", "IP Pharmacy", "", "Yes", "Yes", "Yes"],
    ["11.", "IP EMR", "", "Yes", "Yes", "Yes"],
    ["12.", "MRD", "", "Yes", "Yes", "Yes"],
    ["13.", "Ward & Bed Managemet", "", "Yes", "Yes", "Yes"],
    ["14.", "Radiology", "", "Yes", "Yes", "Yes"],
    ["15.", "IP Billing", "", "Yes", "Yes", "Yes"],
    ["16.", "Cardiology", "", "Yes", "Yes", "Yes"],
    ["17.", "CSSD", "", "", "Yes", "Yes"],
    ["18.", "Operation Theater", "", "", "Yes", "Yes"],
    ["19.", "Doctor Fee Accounting", "", "", "Yes", "Yes"],
    ["20.", "Asset Management", "", "", "Yes", "Yes"],
    ["21.", "MHC", "", "", "Yes", "Yes"],
    ["22.", "HRMS", "", "", "Yes", "Yes"],
    ["23.", "Dialysis", "", "", "", "Yes"],
    ["24.", "Loyalty", "", "", "", "Yes"],
    ["25.", "Feedback", "", "", "", "Yes"],
    ["26.", "Canteen", "", "", "", "Yes"],
    ["27.", "Blood Bank", "", "", "", "Yes"],
    ["28.", "Physiotherapy", "", "", "", "Yes"],
    ["29.", "Dietary", "", "", "", "Yes"],
    ["", "", "", "", "", ""],
    ["", "Integrations", "", "", "", ""],
    ["1.", "Canteen", "", "Yes", "Yes", "Yes"],
    ["2.", "Blood Bank", "", "Yes", "Yes", "Yes"],
    ["3.", "Physiotherapy", "", "Yes", "Yes", "Yes"],
    ["4.", "Dietary", "", "Yes", "Yes", "Yes"],
    ["", "", "", "", "", ""],
    ["", "Mobile Apps", "", "", "", ""],
    ["1.", "Mobile Dashboard", "Yes", "Yes", "Yes", "Yes"],
    ["2.", "Patient Portal", "Yes", "Yes", "Yes", "Yes"],
    ["3.", "Doctor Desk", "Yes", "Yes", "Yes", "Yes"],
    ["4.", "HRMS Mobile Application", "", "", "Yes", "Yes"],
    ["", "", "", "", "", ""],
  ];
  return (
    <>
      <table
        style={{ borderCollapse: "collapse", width: "100%" }}
        className="hims-custom-table"
      >
        <thead
          style={{
            position: "sticky",
            top: "0",
            left: "0",
            backgroundColor: "#f2f5fb",
          }}
        >
          <tr>
            <th
              colSpan={2}
              style={{
                textAlign: "start",
                verticalAlign: "top",
                fontSize: "18px",
                paddingLeft: "16px",
                paddingRight: "24px",
                color: "rgba(84, 83, 83, 1)",
              }}
            >
              Here is the price list with features for all categories. Please
              select a plan as per your convenience.
            </th>
            <th className="table-plan-card-head">
              <PlanCard
                title="Basic"
                pricePerMonth={"00"}
                isActive={true}
                setShowChoosePlan={setShowChoosePlan}
              />
            </th>
            <th className="table-plan-card-head">
              <PlanCard
                title="Standard"
                pricePerMonth={"00"}
                btnBackgrondColor={"rgba(46, 46, 46, 1)"}
                isActive={true}
                setShowChoosePlan={setShowChoosePlan}
              />
            </th>
            <th className="table-plan-card-head">
              <PlanCard
                title="Advanced"
                pricePerMonth={"00"}
                btnBackgrondColor={"rgba(46, 46, 46, 1)"}
                isActive={true}
                setShowChoosePlan={setShowChoosePlan}
              />
            </th>
            <th className="table-plan-card-head">
              <PlanCard
                title="Enterprise"
                pricePerMonth={"00"}
                isActive={true}
                btnBackgrondColor={"rgba(46, 46, 46, 1)"}
                setShowChoosePlan={setShowChoosePlan}
              />
            </th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {row.map((cell, colIndex) => {
                if (colIndex > 1) {
                  return (
                    <td
                      key={colIndex}
                      style={{
                        border: "1px solid #ddd",
                        padding: "16px",
                        backgroundColor: colIndex === 0 ? "#f4f4f4" : "white",
                        fontSize: "22px",
                        width: colIndex === 0 ? "80px" : "auto",
                        textAlign: "center",
                      }}
                    >
                      {cell === "Yes" && (
                        <img
                          style={{ textAlign: "center" }}
                          src={himsCheck}
                          height={24}
                          width={24}
                        />
                      )}
                    </td>
                  );
                } else {
                  return (
                    <td
                      key={colIndex}
                      style={{
                        border: "1px solid #ddd",
                        padding: "16px",
                        backgroundColor: colIndex === 0 ? "#f4f4f4" : "white",
                        fontSize: "18px",
                        width: colIndex === 0 ? "80px" : "400px",
                        height: colIndex === 1 && cell === "" ? "50px" : "auto",
                        fontWeight:
                          cell === "Mobile Apps" ||
                          cell === "Integrations" ||
                          colIndex === 0 ||
                          rowIndex === 0
                            ? "600"
                            : "400",
                      }}
                    >
                      {colIndex <= 1 && <span>{cell}</span>}
                    </td>
                  );
                }
              })}
            </tr>
          ))}
        </tbody>
      </table>
      <ChoosePlan
        isModalOpen={showChoosePlan}
        setIsModalOpen={setShowChoosePlan}
      />
    </>
  );
};
